__turbopack_context__.v({
  "box": "Checkbox-module-scss-module__ntb8-G__box",
  "caption": "Checkbox-module-scss-module__ntb8-G__caption",
  "disabled": "Checkbox-module-scss-module__ntb8-G__disabled",
  "input": "Checkbox-module-scss-module__ntb8-G__input",
  "is_highlight": "Checkbox-module-scss-module__ntb8-G__is_highlight",
  "label": "Checkbox-module-scss-module__ntb8-G__label",
  "labelBlock": "Checkbox-module-scss-module__ntb8-G__labelBlock",
  "mark": "Checkbox-module-scss-module__ntb8-G__mark",
  "markSymbol": "Checkbox-module-scss-module__ntb8-G__markSymbol",
  "size_lg": "Checkbox-module-scss-module__ntb8-G__size_lg",
  "size_md": "Checkbox-module-scss-module__ntb8-G__size_md",
  "size_sm": "Checkbox-module-scss-module__ntb8-G__size_sm",
  "type_default": "Checkbox-module-scss-module__ntb8-G__type_default",
  "type_minimal": "Checkbox-module-scss-module__ntb8-G__type_minimal",
  "with_caption": "Checkbox-module-scss-module__ntb8-G__with_caption",
  "wrapper": "Checkbox-module-scss-module__ntb8-G__wrapper",
  "wrapper_embedded": "Checkbox-module-scss-module__ntb8-G__wrapper_embedded",
});
